import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Result } from 'antd';
import Button from '../../components/UI/Button/Button';
import { ROUTES } from '../../components/AppRouter/AppRouter';

const PaymentResult = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch({ type: 'Cart/RESET' });
  }, [dispatch]);

  const handleGoHome = () => {
    navigate(ROUTES.MAIN);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px',
        backgroundColor: '#fff',
        zIndex: 1,
      }}
    >
      <div style={{ maxWidth: 600, width: '100%', textAlign: 'center' }}>
        <Result
          status="info"
          title={<div style={{ fontSize: '24px' }}>{t('pages.payment.processing')}</div>}
          subTitle={<div style={{ fontSize: '16px', color: '#595959' }}>{t('pages.payment.resultWillBeSent')}</div>}
          extra={
            <Button type="primary" onClick={handleGoHome}>
              {t('button.goHome')}
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default PaymentResult;
